import { ConfigService } from './config.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';
import { userEndpoint } from 'src/app/utils/constants/requestUrl';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private dataSource: BehaviorSubject<string> = new BehaviorSubject<string>('');
  data: Observable<string> = this.dataSource.asObservable();

  constructor(
    private router: Router,
    private configService: ConfigService,
    private http: HttpClient
  ) {}

  sendData(data) {
    this.dataSource.next(data);
  }

  userLoggedInfo(info: boolean) {
    this.dataSource.next(String(info));
  }

  loginUser(username, password) {
    const sanitizedUsername = username?.replace(/[\r\n]/g, '').trim();
    const sanitizedPassword = password?.replace(/[\r\n]/g, '').trim();
    const authorizationData = 'Basic ' + btoa(sanitizedUsername + ':' + sanitizedPassword);
    const headerOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: authorizationData,
        Accept: 'application/json',
      }),
    };
    return this.http.get<any>(`${environment.userUrl}${userEndpoint.loginBackup}`, headerOptions);
  }

  forgotPassword(userid) {
    let params = new HttpParams();
    params = params.append('userID', userid);
    return this.http.get<any>(`${environment.userUrl}${userEndpoint.userForgotPassword}`, {
      params: params,
    });
  }

  signUpUser(userdata): Observable<any> {
    return this.http.post(`${environment.passUrl}${userEndpoint.userSignUp}`, userdata);
  }

  createCustomer(userdata): Observable<any> {
    return this.http.post(`${environment.userUrl}${userEndpoint.customerRegistration}`, userdata);
  }

  createNewPassword(newPassword) {
    return this.http.post(`${environment.userUrl}${userEndpoint.userResetPassword}`, newPassword);
  }

  changePassword(userdata): Observable<any> {
    return this.http.post(`${environment.userUrl}${userEndpoint.userChangePassword}`, userdata);
  }

  refreshPassToken(): Observable<any> {
    const token = this.getAuthToken() || '';
    const sanitizedToken = token.replace(/[\r\n]/g, '').trim();
    const headerOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sanitizedToken}`,
        Accept: 'application/json',
      }),
    };
    return this.http.get(`${environment.passUrl}${userEndpoint.refresh}`, headerOptions);
  }

  refreshToken() {
    let token = this.getRefreshToken() || '';
    token = token.replace(/[\r\n]/g, '').trim();
    const headerOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: token,
        Accept: 'application/json',
      }),
    };
    return this.http.get(`${environment.userUrl}${userEndpoint.getAccessToken}`, headerOptions);
  }

  // TODO: localstorage is not advised
  getAuthToken() {
    const token = sessionStorage.getItem('bbx-token');
    return token;
  }

  getUserRole() {
    const role = sessionStorage.getItem('bbx-role');
    return role;
  }

  getUserCountry() {
    const country = sessionStorage.getItem('bbx-country');
    return country;
  }

  getUserCustomerID() {
    const customerID = sessionStorage.getItem('bbx-customerID');
    return customerID;
  }

  getRefreshToken() {
    const refreshToken = sessionStorage.getItem('bbx-refresh-token');
    return refreshToken;
  }

  saveTokens(token) {
    sessionStorage.setItem('bbx-token', token);
  }

  logOut() {
    sessionStorage.clear();
    this.router.navigateByUrl('/login');
  }

  getUserId() {
    const userID = sessionStorage.getItem('bbx-userID');
    return userID;
  }

  getCustomerId() {
    const customerID = sessionStorage.getItem('bbx-customerID');
    return customerID;
  }

  getCacheValid() {
    const cacheActive = sessionStorage.getItem('cacheActive');
    return cacheActive;
  }

  getAccessTokenWithCode(authCode): Observable<any> {
    let params = new HttpParams();
    const appUrl = window.location.origin;
    params = params.append('code', authCode);
    params = params.append('redirect_url', appUrl);
    return this.http.get(`${environment.passUrl}${userEndpoint.userLogin}`, { params });
  }

  saveLoginInformation(response) {
    // TODO : It should not be localstorage it should be cookies/session with expiry time
    sessionStorage.setItem('isLoggedIn', 'true');
    sessionStorage.setItem('bbx-token', response.token);
    sessionStorage.setItem('bbx-refresh-token', response.refreshtoken);
    sessionStorage.setItem('sid', response?.loggerIds?.sid);
    sessionStorage.setItem('bid', JSON.stringify(response?.loggerIds?.bid));
    this.decodeToken(response?.token);
  }

  logoutUser(): Observable<any> {
    // const data = {};
    return this.http.get(`${environment.passUrl}${userEndpoint.logout}`);
  }

  getCustomersByRole(): Observable<any> {
    return this.http.get(`${environment.userUrl}${userEndpoint.customerList}`);
  }

  async decodeToken(token: string) {
    const decodedToken = await jwtDecode(token);
    sessionStorage.setItem('bbx-userID', decodedToken['userID']);
    sessionStorage.setItem('bbx-customerID', decodedToken['customerID']);
    sessionStorage.setItem('bbx-role', decodedToken['roles'][0]);
    sessionStorage.setItem('bbx-country', decodedToken['country']);
    sessionStorage.setItem('bbx-active', decodedToken['active']);
    sessionStorage.setItem('bbx-rolesarray', JSON.stringify(decodedToken['roles']));
   // sessionStorage.setItem('bbx-customerIdArray', JSON.stringify(decodedToken['customerID_list']));
  }

  getCustomersByCacheStatus(customerId): Observable<any> {
    let params = new HttpParams();
    params = params.append('customerID', customerId);
    return this.http.get(`${environment.userUrl}${userEndpoint.cacheForCustomer}`, { params });
  }
}
